<template>
  <div class="map-view-container">
    <H v-if="title" level="2" size="5" class="mb16"> {{ title }} </H>
    <HotelHotelsMap :hotels="hotelLocations" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  title: {
    type: String,
    default: null,
  },
});

const { hotels } = useHotels();
const hotelLocations = computed(() => {
  return hotels.value.map((hotel) => ({
    name: hotel.name,
    url: hotel.slug,
    lat: hotel.coordinates?.lat,
    lng: hotel.coordinates?.lon,
  }));
});
</script>
